export enum VariableBenefitPaymentFrequencyEnum {
  Monthly = 1,
  Annually = 2
}
